import React, { useEffect, useState } from 'react';
import API_BASE_URL from '../../../components/apiconfig/api-config';
import NoRecordFound from '../../../components/common/no-record-found';

const CombinedSalesReportMIS = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE_URL}/api/report/combined-sales-report-mis`, { credentials: 'include' });
        if (!res.ok) throw new Error('Failed to fetch');
        const result = await res.json();
        setData(result.data || []);
      } catch (err) {
        setError('Failed to load combined sales report MIS');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="max-w-8xl mx-auto p-6 bg-white shadow-sm border border-gray-100">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Combined Sales Report MIS</h2>
          <p className="text-sm text-gray-500 mt-1">Summary of contracts, orders, dispatches, and balances</p>
        </div>
      </div>
      {loading ? (
        <div className="flex flex-col items-center justify-center py-12 space-y-3">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600"></div>
          <p className="text-sm text-gray-600">Loading combined sales report MIS...</p>
        </div>
      ) : error ? (
        <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-lg">
          <h3 className="text-sm font-medium text-red-800">Error loading data</h3>
          <p className="text-sm text-red-700 mt-1">{error}</p>
        </div>
      ) : data.length === 0 ? (
        <NoRecordFound message="No records found" subMessage="No data available for the selected criteria" iconClass="text-gray-400" />
      ) : (
        <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-xs">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-gray-50 text-gray-700 font-semibold">
              <tr>
                <th className="px-4 py-2 text-left">Contract No.</th>
                <th className="px-4 py-2 text-left">Buyer Name</th>
                <th className="px-4 py-2 text-left">Material</th>
                <th className="px-4 py-2 text-right">Contract Qty (MT)</th>
                <th className="px-4 py-2 text-right">Ordered Qty (MT)</th>
                <th className="px-4 py-2 text-right">Dispatched Qty (MT)</th>
                <th className="px-4 py-2 text-right">Balance Qty (MT)</th>
                <th className="px-4 py-2 text-right">Rate/MT</th>
                <th className="px-4 py-2 text-right">Total Value (INR)</th>
                <th className="px-4 py-2 text-center">Status</th>
                <th className="px-4 py-2 text-left">Last Dispatch Date</th>
                <th className="px-4 py-2 text-left">Warehouse</th>
                <th className="px-4 py-2 text-left">Vehicle No.</th>
                <th className="px-4 py-2 text-left">Remarks</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {data.map((row, idx) => (
                <tr key={idx}>
                  <td className="px-4 py-3">{row.contract_no}</td>
                  <td className="px-4 py-3">{row.buyer_name}</td>
                  <td className="px-4 py-3">{row.material}</td>
                  <td className="px-4 py-3 text-right font-mono">{row.contract_qty_mt}</td>
                  <td className="px-4 py-3 text-right font-mono">{row.ordered_qty_mt}</td>
                  <td className="px-4 py-3 text-right font-mono">{row.dispatched_qty_mt}</td>
                  <td className="px-4 py-3 text-right font-mono">{row.balance_qty_mt}</td>
                  <td className="px-4 py-3 text-right font-mono">{row.rate_per_mt}</td>
                  <td className="px-4 py-3 text-right font-mono">{row.total_value_inr}</td>
                  <td className="px-4 py-3 text-center font-semibold">{row.status}</td>
                  <td className="px-4 py-3">{row.last_dispatch_date}</td>
                  <td className="px-4 py-3">{row.warehouse}</td>
                  <td className="px-4 py-3">{row.vehicle_no}</td>
                  <td className="px-4 py-3">{row.remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CombinedSalesReportMIS;
